import { apiClient } from '@/shared/api';

import type {
  CouponCodeList,
  CouponCodeResponse,
  CouponPage,
  CouponRequest,
  CouponResponse,
  GenerateCodesRequest,
} from '../model/types';

const BASE = '/api/v1/catalog/promo/coupons';

export interface ListCouponsParams {
  page?: number;
  size?: number;
}

export const listCoupons = async (params: ListCouponsParams = {}): Promise<CouponPage> =>
  (await apiClient.get<CouponPage>(BASE, { params })).data;

export const createCoupon = async (body: CouponRequest): Promise<CouponResponse> =>
  (await apiClient.post<CouponResponse>(BASE, body)).data;

export const getCoupon = async (couponId: string): Promise<CouponResponse> =>
  (await apiClient.get<CouponResponse>(`${BASE}/${couponId}`)).data;

export const activateCoupon = async (couponId: string): Promise<CouponResponse> =>
  (await apiClient.post<CouponResponse>(`${BASE}/${couponId}/activate`)).data;

export const pauseCoupon = async (couponId: string): Promise<CouponResponse> =>
  (await apiClient.post<CouponResponse>(`${BASE}/${couponId}/pause`)).data;

export const endCoupon = async (couponId: string): Promise<CouponResponse> =>
  (await apiClient.post<CouponResponse>(`${BASE}/${couponId}/end`)).data;

export const listCouponCodes = async (couponId: string): Promise<CouponCodeList> =>
  (await apiClient.get<CouponCodeList>(`${BASE}/${couponId}/codes`)).data;

export const generateCouponCodes = async (
  couponId: string,
  body: GenerateCodesRequest,
): Promise<CouponCodeList> =>
  (await apiClient.post<CouponCodeList>(`${BASE}/${couponId}/codes/generate`, body)).data;

/** CSV export — returns the raw text so the caller can trigger a browser download. */
export const exportCouponCodes = async (couponId: string): Promise<string> =>
  (
    await apiClient.get<string>(`${BASE}/${couponId}/codes/export`, {
      responseType: 'text',
      headers: { Accept: 'text/csv' },
    })
  ).data;

export const deactivateCouponCode = async (
  couponId: string,
  codeId: string,
): Promise<CouponCodeResponse> =>
  (await apiClient.post<CouponCodeResponse>(`${BASE}/${couponId}/codes/${codeId}/deactivate`)).data;
